// Ссылка на маршрут для "Поделиться" - один формат для деталей маршрута и
// карточек профиля: <origin>/route/<код> (без числового id). Без кода
// (маршрут ещё без slug) - прежняя ссылка с ?route=<id>, она тоже работает.
export const buildRouteShareUrl = (origin: string, route: { id: number; slug?: string | null }, basePath = import.meta.env.BASE_URL.replace(/\/$/, "")): string =>
  route.slug ? `${origin}${basePath}/route/${route.slug}` : `${origin}${basePath}/map?route=${route.id}`;

export type ShareOutcome = "shared" | "copied" | "failed";

// Системное окно шаринга, а без него - копирование ссылки. "shared" -
// сработало окно (или пользователь его закрыл), "copied" - ссылка в
// буфере, "failed" - ни то ни другое (тогда вызывающий показывает саму
// ссылку).
export const shareRouteLink = async (url: string, title: string): Promise<ShareOutcome> => {
  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title, url });
    } catch {
      /* пользователь отменил системное окно шаринга */
    }
    return "shared";
  }
  try {
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    return "failed";
  }
};
